module.exports = __webpack_public_path__ + "static/Oxford VR-ce18cf23b3b5f4aa2f266850f023b5b2.jpg";